import * as React from 'react';
import { GlobalPrivateState, formatMessage } from 'src/api';
import { connect } from 'react-redux';
import { CartModel, ConfigurationModel, getMarketByCountryCode } from 'franke-trough-dependencies';
import { FormattedNumber } from 'react-intl';
import CheckoutButton from './Parts/CheckoutButton';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './checkout.messages';
import PeriodSelection from './Parts/PeriodSelection';

export interface  TotalPriceCheckoutProps {
  checkout: GlobalPrivateState['checkout'];
  configuration: GlobalPrivateState['configuration'];
  clientInfo: GlobalPrivateState['clientInfo'];
  user: GlobalPrivateState['user'];
  userData: GlobalPrivateState['userData'];
  pricings: GlobalPrivateState['pricings'];
}

export class TotalPriceCheckout extends React.Component<TotalPriceCheckoutProps, any> {
  private getTermsLink() {
    const configuration = this.props.configuration.result;
    const userData = this.props.userData.result;
    const defaultLink = 'https://kwc-professional.com/en_global/footer-pages/terms-and-conditions';

    if (!configuration || !configuration.country || !userData || !userData.lang) { return defaultLink }

    const market = getMarketByCountryCode(this.props.pricings.result, configuration.country);

    if (!market || !market.termLinks) { return defaultLink }

    const termLink = market.termLinks.find(t => t.lang === userData.lang.split('-')[0]);

    return termLink && termLink.url || defaultLink;
  }

  public render() {
    const { configuration, pricings } = this.props;
    const checkout = this.checkout;

    const selectedPeriodAccessories = configuration.result && configuration.result.pricingsAccessoriesId 
      || configuration.result && configuration.result.pricingsAccessories && configuration.result.pricingsAccessories.id 
      || checkout && checkout.pricingsAccessoriesIdFallback;
    const selectedPeriodWashbasin = configuration.result && configuration.result.pricingsWashbasinId 
      || configuration.result && configuration.result.pricingsWashbasin && configuration.result.pricingsWashbasin.id 
      || checkout && checkout.pricingsWashbasinIdFallback;

    // Get most recent date end...
    let soonestEndDate: any;
    if (pricings && pricings.result) {
      pricings.result.map(pricing => {
        if (pricing.id === selectedPeriodAccessories || pricing.id === selectedPeriodWashbasin) {
          const dateUntil = new Date(pricing.dateUntil);
          if (!soonestEndDate || dateUntil.getTime() < soonestEndDate.getTime()) {
            soonestEndDate = dateUntil;
          }
        }
      });
    }

    return (
      <div className="total-price-line">
        {checkout && checkout.totals && (
          <>
            <div className="price-sub border-bottom mb-4 pb-3">
              <div className="row">
                <div className="col-8">
                  <h4 className="mb-1">
                    <FormattedMessage {...MESSAGES.totalPriceWashbasin} />
                  </h4>
                </div>
                <div className="col-4 text-right">
                  <h4 className="mb-1">
                    <FormattedNumber 
                      currency={checkout.currency}
                      currencyDisplay="code"
                      style="currency"
                      value={checkout.subTotals.configuration.net}
                      minimumFractionDigits={0}
                    />
                  </h4>
                </div>
                {checkout.totals.deliveryCosts && checkout.totals.deliveryCosts > 0 && (
                  <>
                  <div className="col-6">
                    <h4 className="mb-1">
                      <FormattedMessage {...MESSAGES.totalPriceDeliveryCosts} />
                    </h4>
                  </div>
                  <div className="col-6 text-right">
                    <h4 className="mb-1">
                      <FormattedNumber 
                        currency={checkout.currency}
                        currencyDisplay="code"
                        style="currency"
                        value={checkout.totals.deliveryCosts}
                        minimumFractionDigits={0}
                      />  
                    </h4>
                  </div>
                  </>
                )}

                {checkout && checkout.lines && checkout.lines.parts && (
                  <>
                    <div className="col-8">
                      <h4 className="mb-1">
                        <FormattedMessage {...MESSAGES.totalPriceParts} />
                      </h4>
                    </div>
                    <div className="col-4 text-right">
                      <h4 className="mb-1">
                        <FormattedNumber 
                          currency={checkout.currency}
                          currencyDisplay="code"
                          style="currency"
                          value={checkout.subTotals.parts.base}
                        />
                      </h4>
                    </div>
                  </>
                )}

                <div className="col-6">
                  <h4><FormattedMessage {...MESSAGES.totalPriceVat} /> <FormattedNumber style="decimal" value={checkout.vat} />%</h4>
                </div>
                <div className="col-6 text-right">
                  <h4>
                    <FormattedNumber 
                      currency={checkout.currency}
                      currencyDisplay="code"
                      style="currency"
                      value={checkout.totals.vat}
                    />
                  </h4>
                </div>

              </div>
              <div className="row">
                <div className="col-9">
                  <small>
                    <a href= {this.getTermsLink()} className="mb-1" target="_blank">{formatMessage(MESSAGES.legalsLabel)}</a>
                  </small>
                </div>
              </div>
            </div>
            <div className="price-total border-bottom mb-4 pb-3">
              <div className="row">
                <div className="col-6">
                  <span className="total-price">
                    <FormattedMessage {...MESSAGES.totalPriceTotal} />
                  </span>
                </div>
                <div className="col-6 text-right">
                  <span className="total-price">
                    <FormattedNumber 
                      currency={checkout.currency}
                      currencyDisplay="code"
                      style="currency"
                      value={checkout.totals.total}
                    />
                  </span>
                </div>
                {soonestEndDate && (
                  <div className="col-12 mt-3">
                    <small><strong className="d-block"><FormattedMessage {...MESSAGES.totalPriceNote} /></strong> <FormattedMessage {...MESSAGES.totalPriceNoteText} /> {soonestEndDate.toLocaleDateString("en-GB")}</small>
                  </div>
                )}
              </div>
            </div>
          </>
        )}

        <div className="order-offer">
          <div className="row">
            <CheckoutButton />
          </div>
        </div>

        <div className="period-selection">
          <div className="row">
            <PeriodSelection />
          </div>
        </div>
      </div>
    );
  }

  private get checkout(): CartModel |undefined {
    const { checkout } = this.props;
    return checkout && checkout.result;
  }

  private get configuration(): ConfigurationModel |undefined {
    const { configuration } = this.props;
    return configuration && configuration.result;
  }
}

export const TotalPriceCheckoutComponent = connect((state: GlobalPrivateState) => ({
  checkout: state.checkout,
  configuration: state.configuration,
  clientInfo: state.clientInfo,
  user: state.user,
  userData: state.userData,
  authenticator: state.authenticator,
  pricings: state.pricings,
}))(TotalPriceCheckout);

export default TotalPriceCheckoutComponent;